export class NumeroUtil {

    public static sort(n1: number | null | undefined, n2: number | null | undefined): number {
        if (!n1) {
            n1 = 0;
        }
        if (!n2) {
            n2 = 0;
        }
        if (n1 == n2) {
            return 0;
        }
        if (n2 > n1) {
            return -1;
        }
        return 1;
    }

    public static sortNumberAsString(s1: string | undefined, s2: string | undefined): number {
        let n1 = 0;
        let n2 = 0;

        if (s1) {
            n1 = +s1;
        }
        if (s2) {
            n2 = +s2;
        }
        return NumeroUtil.sort(n1, n2);
    }
}